<script setup>
import { computed, reactive, ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['create']);

const copy = {
  title: 'Gerar contrato',
  description: 'Preencha os dados para gerar o contrato para o cliente.',
  template: 'Modelo de contrato',
  selectTemplate: 'Selecione um modelo',
  name: 'Nome do cliente',
  cpf: 'CPF',
  phone: 'Telefone',
  cancel: 'Cancelar',
  confirm: 'Gerar contrato',
};

const dialogRef = ref(null);
const templates = ref([]);
const form = reactive({
  templateId: '',
  recipientName: '',
  recipientCpf: '',
  recipientPhone: '',
});

const isConfirmDisabled = computed(
  () => !form.templateId || !form.recipientName.trim()
);

const open = (contractTemplates, contact) => {
  templates.value = contractTemplates || [];
  form.templateId = '';
  form.recipientName = contact?.name || '';
  form.recipientCpf = '';
  form.recipientPhone = contact?.phone_number || '';
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const handleConfirm = () => {
  if (isConfirmDisabled.value) return;
  emit('create', { ...form });
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="md"
    :title="copy.title"
    :description="copy.description"
    :cancel-button-label="copy.cancel"
    :confirm-button-label="copy.confirm"
    :disable-confirm-button="isConfirmDisabled"
    @confirm="handleConfirm"
  >
    <div class="grid gap-4">
      <label class="grid gap-1.5 text-sm font-medium text-n-slate-12">
        {{ copy.template }}
        <select
          v-model="form.templateId"
          class="text-n-slate-12 block h-10 w-full px-3 py-2 pr-6 mb-0 border-0 shadow-sm appearance-none rounded-xl select-caret leading-6 bg-n-background"
        >
          <option value="">{{ copy.selectTemplate }}</option>
          <option v-for="t in templates" :key="t.id" :value="t.id">
            {{ t.name }}
          </option>
        </select>
      </label>
      <label class="grid gap-1.5 text-sm font-medium text-n-slate-12">
        {{ copy.name }}
        <input
          v-model="form.recipientName"
          type="text"
          class="h-10 w-full !mb-0 rounded-xl border border-n-weak bg-n-background px-3 text-sm text-n-slate-12 outline-none focus:border-n-brand"
        />
      </label>
      <label class="grid gap-1.5 text-sm font-medium text-n-slate-12">
        {{ copy.cpf }}
        <input
          v-model="form.recipientCpf"
          type="text"
          class="h-10 w-full !mb-0 rounded-xl border border-n-weak bg-n-background px-3 text-sm text-n-slate-12 outline-none focus:border-n-brand"
        />
      </label>
      <label class="grid gap-1.5 text-sm font-medium text-n-slate-12">
        {{ copy.phone }}
        <input
          v-model="form.recipientPhone"
          type="tel"
          class="h-10 w-full !mb-0 rounded-xl border border-n-weak bg-n-background px-3 text-sm text-n-slate-12 outline-none focus:border-n-brand"
        />
      </label>
    </div>
  </Dialog>
</template>
